import React from "react";
import { CategoryTitle } from "../styles/StyledComponents";
import EndpointCard from "./EndpointCard";

/**
 * Renders a list of API endpoints grouped by category
 * @param {Object} props - Component props
 * @param {Object} props.categories - Object with categories as keys and arrays of endpoints as values
 * @param {Function} props.onSelectEndpoint - Function to call when an endpoint is selected
 * @param {Object} props.apiCallResults - Results of API calls
 * @param {boolean} props.groupByMethod - Whether to group endpoints by method
 * @returns {JSX.Element}
 */
const EndpointList = ({ categories, onSelectEndpoint, apiCallResults, groupByMethod = false }) => {
  if (groupByMethod) {
    // Render endpoints grouped by HTTP method
    return (
      <>
        {Object.entries(categories).map(([method, endpoints]) => (
          <div key={method}>
            <CategoryTitle>
              <EndpointCard endpoint={{ method, name: `${method} Endpoints` }} showMethod={false} onSelect={() => {}} />
            </CategoryTitle>
            {endpoints.map(endpoint => {
              const endpointKey = `${endpoint.method}-${endpoint.path}`;
              const result = apiCallResults[endpointKey];

              return (
                <EndpointCard
                  key={endpointKey}
                  endpoint={endpoint}
                  onSelect={onSelectEndpoint}
                  result={result}
                  showCategory={true}
                />
              );
            })}
          </div>
        ))}
      </>
    );
  }

  // Render endpoints grouped by service category
  return (
    <>
      {Object.entries(categories).map(([category, endpoints]) => (
        <div key={category}>
          <CategoryTitle>{category}</CategoryTitle>
          {endpoints.map(endpoint => {
            const endpointKey = `${endpoint.method}-${endpoint.path}`;
            const result = apiCallResults[endpointKey];

            return <EndpointCard key={endpointKey} endpoint={endpoint} onSelect={onSelectEndpoint} result={result} />;
          })}
        </div>
      ))}
    </>
  );
};

export default EndpointList;
